import { Statistic } from "antd";
import { PendingIcon, PrizeIcon, QuotesIcon } from "../icon";
import CountUp from "react-countup";
import { valueType } from "antd/es/statistic/utils";
import Typography from "../Typography/Typography";
import useGetQuoteStatistic from "@/common/api/queries/quoteQueries/useGetGlobalQuoteStatistic.query";
import { usePermissions } from "@/common/contexts/Permissions.context";
import useGetMeQuoteStatistic from "@/common/api/queries/quoteQueries/useGetMeQuoteStatistic.query";
import { useMemo, useState } from "react";

export default function StatisticsData() {
  const { company } = usePermissions();
  const formatter = (value: valueType) => (
    <CountUp end={Number(value)} separator="," />
  );
  const [statisticData, setStatisticData] = useState<any>();
  const { data: globalStatisticData } = useGetQuoteStatistic("month");
  const { data: meStatisticData } = useGetMeQuoteStatistic("month");

  useMemo(() => {
    if (!company) return;
    if (company?.companyType === "airx") {
      return setStatisticData(globalStatisticData);
    }
    return setStatisticData(meStatisticData);
  }, [company, globalStatisticData, meStatisticData]);

  return (
    <div className="px-5 flex gap-5 flex-2 justify-between">
      <Statistic
        className="flex justify-between p-3 rounded-lg bg-white items-center w-full"
        title={
          <div className="flex items-center gap-2">
            <div className="rounded-full bg-info w-12 h-12 flex items-center justify-center text-primary">
              <QuotesIcon />
            </div>
            <Typography
              type="p"
              fontFamily="font-kanit"
              fontWeight="font-light"
              textColor="blackTransparent-60"
            >
              {company && company?.companyType === "customer"
                ? "Total quote lines"
                : "Total quotes"}
            </Typography>
          </div>
        }
        valueRender={(value) => (
          <Typography
            type="p"
            fontFamily="font-kanit"
            fontWeight="font-medium"
            fontSize={28}
            lineHeight={42 / 28}
          >
            {value}
          </Typography>
        )}
        value={statisticData?.totalQuotes}
        formatter={formatter}
        key={"Total quotes" + statisticData?.totalQuotes}
      />
      <Statistic
        className="flex justify-between p-3 rounded-lg bg-white items-center w-full"
        title={
          <div className="flex items-center gap-2">
            <div className="rounded-full bg-info w-12 h-12 flex items-center justify-center text-primary">
              <PendingIcon />
            </div>
            <Typography
              type="p"
              fontFamily="font-kanit"
              fontWeight="font-light"
              textColor="blackTransparent-60"
            >
              Total pending
            </Typography>
          </div>
        }
        valueRender={(value) => (
          <Typography
            type="p"
            fontFamily="font-kanit"
            fontWeight="font-medium"
            fontSize={28}
            lineHeight={42 / 28}
          >
            {value}
          </Typography>
        )}
        value={statisticData?.pendingQuotes}
        formatter={formatter}
        key={"Total pending" + statisticData?.pendingQuotes}
      />
      <Statistic
        className="flex justify-between p-3 rounded-lg bg-white items-center w-full"
        title={
          <div className="flex items-center gap-2">
            <div className="rounded-full bg-info w-12 h-12 flex items-center justify-center text-primary">
              <PrizeIcon />
            </div>

            <Typography
              type="p"
              fontFamily="font-kanit"
              fontWeight="font-light"
              textColor="blackTransparent-60"
            >
              {company && company?.companyType === "customer"
                ? "Total won quote lines"
                : "Total won quotes"}
            </Typography>
          </div>
        }
        valueRender={(value) => (
          <Typography
            type="p"
            fontFamily="font-kanit"
            fontSize={28}
            fontWeight="font-medium"
            lineHeight={42 / 28}
          >
            {value}
          </Typography>
        )}
        value={statisticData?.wonQuoted}
        formatter={formatter}
        key={"Total won quotes" + statisticData?.wonQuoted}
      />
      <Statistic
        className="flex justify-between p-3 rounded-lg bg-white items-center  w-full"
        title={
          <div className="flex items-center gap-2">
            <div className="rounded-full bg-info w-12 h-12 flex items-center justify-center text-primary text-xl text-center cursor-default">
              %
            </div>
            <Typography
              type="p"
              fontFamily="font-kanit"
              fontWeight="font-light"
              textColor="blackTransparent-60"
            >
              Quote Success Rate
            </Typography>
          </div>
        }
        valueRender={(value) => (
          <Typography
            type="p"
            fontFamily="font-kanit"
            fontSize={28}
            fontWeight="font-medium"
            lineHeight={42 / 28}
            className="text-nowrap"
          >
            {value}%
          </Typography>
        )}
        value={statisticData?.quoteSuccessRate}
        formatter={formatter}
        key={"Quote Success Rate" + statisticData?.quoteSuccessRate}
      />
    </div>
  );
}
